import React from 'react';
import { Box } from '@mui/material';

const RiegoAnalysis = () => <Box />;

export default RiegoAnalysis;
